import { useParams, Navigate } from 'react-router-dom';
import { useStore } from '../context/ProductStore';
import ProductForm from '../components/ProductForm';

export default function EditProduct() {
  const { id } = useParams();
  const { products } = useStore();
  const product = products.find(p => String(p.id) === String(id));
  if (!product) return <Navigate to="/admin/products" />;
  return <ProductForm existing={product} />;
}
